import { ICellRendererParams } from "@ag-grid-community/core";
import { HStack, Text } from "@chakra-ui/react";
import { IRegistryDataColumn } from "../../../models/RegistryDataColumn";
import { MaterialIcon } from "../../shared/MaterialIcon";

interface IProps extends ICellRendererParams {
  meta?: IRegistryDataColumn;
}

export const CellLocked = (props: IProps) => {
  let cellValue = props.value;

  // If being grouped, could have layered values
  if (props.value && props.value.hasOwnProperty("value")) {
    cellValue = props.value.value;
  }

  return (
    <HStack h="full" px={2} spacing="2">
      <MaterialIcon
        name="lock"
        fontSize="1rem"
        color={"text.softer"}
        variant="outline"
      />
      <Text as="i" size="xs" noOfLines={1} w="full">
        {cellValue}
      </Text>
    </HStack>
  );
};
